import React, { useState, useEffect, useContext } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { useCity } from '../../hooks/CompanyConfiguration/useCity'
import { useLocation } from '../../hooks/Location/useLocation'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useRegion } from '../../hooks/CompanyConfiguration/useRegion'
import { sortByName } from '../../shared/constants'
import { ROUTES } from '../../shared/constants'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'

export default function CityForm() {

  const [cityData, setCityData] = useState({
    name: '',
    region: '',
    zone: '',
    state: '',
    district: '',
    cityCode: '',
  })

  const { addCity, loading } = useCity()
  const { getAllRegion } = useRegion()

  const { regions } = useContext(ConfigurationContext)
  const { zones, getAllZone, getAllState, states, districts, getAllDistrict } = useLocation()

  useEffect(() => {
    getAllRegion()
  }, [])

  useEffect(() => {
    if (cityData.region) {
      getAllZone({ region: cityData.region })
    }
    if (cityData.zone) {
      getAllState({ region: cityData.region, zone: cityData.zone })
    }
    if (cityData.state) {
      getAllDistrict({ region: cityData.region, zone: cityData.zone, state: cityData.state })
    }
  }, [cityData])

  const handelAddCity = () => {
    addCity(cityData)
  }
  

  const data = [
    { label: 'City Code', value: cityData.cityCode, name: 'cityCode' },
    { label: 'Name', value: cityData.name, name: 'name' },
    { label: 'Region', value: cityData.region, name: 'region', options: sortByName(regions), fieldName: 'name', fieldValue: '_id' },
    { label: 'Zone', value: cityData.zone, name: 'zone', options: sortByName(zones), fieldName: 'name', fieldValue: '_id' },
    { label: 'State', value: cityData.state, name: 'state', options: sortByName(states), fieldName: 'name', fieldValue: '_id' },
    { label: 'District', value: cityData.district, name: 'district', options: sortByName(districts), fieldName: 'name', fieldValue: '_id' },
  ]

  return (
    <Layout heading="City" heading2="Add" url1={ROUTES.CITY} none>
      <HeaderTabLayout
        heading="Add City"
        state={cityData} setState={setCityData}
        content={<CustomAddForm state={cityData} setState={setCityData} data={data} />}
        addContent={handelAddCity}
        redirect={ROUTES.CITY}
        loading={loading}
      />
    </Layout>
  )
}